import CountryFlag from 'react-country-flag';

export interface FlagIconProps {
  countryCode?: string;
  width?: number;
  height?: number;
}

export function FlagIcon({ countryCode = 'US', width = 18, height = 18, ...props }: FlagIconProps) {
  return (
    <CountryFlag
      countryCode={countryCode}
      svg
      style={{
        width: `${width}px`,
        height: `${height}px`,
        borderRadius: '3px',
      }}
      {...props}
    />
  );
}
